import { FC } from 'react'

import OIDCLogo from '@/assets/logos/oidc.svg?react'
import ServiceIntegrationCard from '@/components/service-integration-card'
import { SSO } from '@/out/single-sign-on'
import { SSOProps } from '@/pages/settings/single-sign-on'
import OIDCDetails from '@/pages/settings/single-sign-on/oidc/details'
import OIDCForm from '@/pages/settings/single-sign-on/oidc/form'

type Props = SSOProps<'oidc'> & {
  configuration: SSO['oidc']
  disabled?: boolean
}

const OIDC: FC<Props> = ({ configuration, setupTimer, onSetup, removeTimer, onRemove, disabled = false }) => {
  return (
    <ServiceIntegrationCard
      title="OIDC"
      description="Set up an OIDC provider for single sign-on."
      icon={<OIDCLogo className="w-8 h-8" />}
      iconColor="text-[#f37e4e]"
      isConnected={!!configuration}
      disabled={disabled}
      disabledMessage="Disable the current provider to enable this one"
      setupContent={<OIDCForm timer={setupTimer} onSetup={config => onSetup('oidc', config)} />}
      manageContent={
        configuration ? (
          <OIDCDetails
            configuration={configuration}
            timer={removeTimer}
            onRemove={() => {
              onRemove('oidc')
            }}
          />
        ) : undefined
      }
    />
  )
}

export default OIDC
